import { render, staticRenderFns } from "./Portfolio.vue?vue&type=template&id=1d31e86b&scoped=true&"
import script from "./Portfolio.vue?vue&type=script&lang=js&"
export * from "./Portfolio.vue?vue&type=script&lang=js&"
import style0 from "./Portfolio.vue?vue&type=style&index=0&id=1d31e86b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d31e86b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d31e86b')) {
      api.createRecord('1d31e86b', component.options)
    } else {
      api.reload('1d31e86b', component.options)
    }
    module.hot.accept("./Portfolio.vue?vue&type=template&id=1d31e86b&scoped=true&", function () {
      api.rerender('1d31e86b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/domains/profile/components/ProfileField/field-types/Portfolio.vue"
export default component.exports